module.exports = __webpack_public_path__ + "img/FGr_Wassergefahren_B.cf108dde.svg";